module.exports = __webpack_public_path__ + "img/loader.af72f563.png";